import { toValue } from 'vue';

export default function estimatePreviewBitrate({ encoderType, encoderQuality, fps }) {
  if (toValue(encoderType) === 'webp') {
    return (5 * toValue(encoderQuality) + 50) * toValue(fps);
  }
  return (6 * toValue(encoderQuality) + 140) * toValue(fps);
}
